module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Purchases","noPurchases":"No purchases yet."},"es":{"title":"Compras","noPurchases":"Sin compras todavía."},"sw":{"title":"Manunuzi","noPurchases":"Hakuna ununuzi bado."}}')
  delete Component.options._Ctor
}
